module.exports = __webpack_public_path__ + "img/img-no-data.a0945a6e.png";